"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyQuery = exports.parseQuery = void 0;
// tslint:disable-next-line:no-var-requires
var qs = require('query-string');
var parseQuery = function (search) {
    return qs.parse(search);
};
exports.parseQuery = parseQuery;
var stringifyQuery = function (query) {
    return qs.stringify(query);
};
exports.stringifyQuery = stringifyQuery;
//# sourceMappingURL=query.js.map